import { StrictMode } from 'react';
import GlobalStyles from '~/components/GlobalStyles';
import Routes from '~/containers/Routes';
import { ThemePickerProvider } from '~/context/theme-picker';
import '~/assets/stylesheets/global.css';
import './radix-overrides.css';

function RootContainer() {
  return (
    <StrictMode>
      <ThemePickerProvider>
        <GlobalStyles />
        <Routes />
      </ThemePickerProvider>
    </StrictMode>
  );
}

export default RootContainer;
